import React, { CSSProperties, PropsWithChildren, ReactNode } from "react";
import { BlueBirdTheme, Typography } from "@kitbird/core";

const {
  blueGray,
  danger,
  gray,
  primary,
  rating,
  success,
  warning,
  white,
} = BlueBirdTheme.colors;

export enum StatusEnums {
  PRIMARY = "PRIMARY",
  WARNING = "WARNING",
  DANGER = "DANGER",
  SUCCESS = "SUCCESS",
  INACTIVE = "INACTIVE",
  BLACKLIST = "BLACKLIST",
  RATING = "RATING",
}

export interface StatusProps extends PropsWithChildren {
  content?: string | ReactNode
  status?: StatusEnums
  className?: string
  textColorAsBgColor?: boolean
  style?: CSSProperties
}

export const generateColor = (status: StatusEnums) => {
  const color = {
    [StatusEnums.PRIMARY]: { text: primary[500], background: primary[200] },
    [StatusEnums.WARNING]: { text: warning[500], background: warning[200] },
    [StatusEnums.DANGER]: { text: danger[500], background: danger[200] },
    [StatusEnums.SUCCESS]: { text: success[500], background: success[200] },
    [StatusEnums.INACTIVE]: { text: gray.disable, background: "#DFE0E9" },
    [StatusEnums.BLACKLIST]: { text: white, background: blueGray.dark },
    [StatusEnums.RATING]: { text: rating[600], background: rating[200] },
  }[status];
  return color;
};

const Status = ({
  content = "",
  status = StatusEnums.PRIMARY,
  className,
  children,
  textColorAsBgColor = false,
  style,
}: StatusProps) => {
  const color = generateColor(status);

  return (
    <div
      className={className}
      style={{
        backgroundColor: textColorAsBgColor ? color.text : color.background,
        color: textColorAsBgColor ? white : color.text,
        padding: "6px 24px",
        borderRadius: 12,
        width: "fit-content",
        ...style,
      }}>
      {children || <Typography level={8} fontWeight="medium">
        {content}
      </Typography>
      }
    </div>
  );
};
export interface StatusBoxProps extends PropsWithChildren {
  status?: StatusEnums
  className?: string
}

export const StatusBox = ({
  status = StatusEnums.PRIMARY,
  className,
  children,
}: StatusBoxProps) => {
  const color = generateColor(status);

  return (
    <div
      className={className}
      style={{
        backgroundColor: status === StatusEnums.INACTIVE ? gray.background : color.background,
        color: color.text,
        padding: 12,
        borderRadius: 12,
        width: "100%",
        boxSizing: "border-box",
      }}>
      {children}
    </div>
  );
};

export default Status;
